import { render, staticRenderFns } from "./AudioTool.vue?vue&type=template&id=e87a8444"
import script from "./AudioTool.vue?vue&type=script&lang=js"
export * from "./AudioTool.vue?vue&type=script&lang=js"
import style0 from "./AudioTool.vue?vue&type=style&index=0&id=e87a8444&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports